import(/* webpackMode: "eager" */ "/vercel/path0/app/talento/perfiles/page.tsx");
